<script setup>
import {useFlowStore} from "../../Registration/stores/flowStore";
import {computed} from "vue";
import {useBookingStore} from "../../Registration/stores/bookingStore";
import {useSettingsManager} from "../../Registration/stores/settingsManagerStore";

const {settings} = useSettingsManager();
const flow = useFlowStore();
const booking = useBookingStore();
const canEdit = computed(() => {
    if(booking.status === 'waitlisted'){
        return false;
    }
    if (settings?.afterFormSubmissionSettings?.edit_allowed) {
        return settings?.afterFormSubmissionSettings?.edit_allowed_status.includes(booking.status);
    }
    return false;
})
</script>

<template>
    <div class="flex justify-center" v-if="canEdit">
        <button
            type="button"
            class="btn btn-action btn-primary btn-edit-registration justify-center items-center mt-3"
            @click="flow.activateFormEdition"
            :aria-label="settings['editButtonText']"
        >
            <span>{{ settings['editButtonText'] }}</span>
        </button>
    </div>
</template>

<style scoped>

</style>
